import { EventInternalContent } from "../queries/getItem";
import { normalizeSurveyPeriodDates } from "./surveyUtils";

export const parseInternalContentJSON = (raw?: string): EventInternalContent => {
  const empty: EventInternalContent = {
    version: 2,
    modules: [],
    transmissions: [],
    recordings: [],
    materials: [],
    announcements: [],
  };

  if (!raw) return empty;

  try {
    const parsed = JSON.parse(raw);
    return {
      ...empty,
      ...parsed,
      survey: normalizeSurveyPeriodDates(parsed?.survey),
    };
  } catch {
    throw new Error("O conteúdo interno salvo neste evento possui um JSON inválido.");
  }
};
